// src/components/CustomCursor.js
import React, { useEffect } from 'react';


const CustomCursor = () => {
    useEffect(() => {
        const cursor = document.getElementById('custom-cursor');

        // Cursor movement logic
        const moveCursor = (e) => {
            cursor.style.left = `${e.clientX}px`;
            cursor.style.top = `${e.clientY}px`;
        };

        // Add event listener for mouse movement
        document.addEventListener('mousemove', moveCursor);

        // Change cursor on hover over links
        const addHoverEffect = () => cursor.classList.add('hover');
        const removeHoverEffect = () => cursor.classList.remove('hover');
        const links = document.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('mouseenter', addHoverEffect);
            link.addEventListener('mouseleave', removeHoverEffect);
        });

        // Clean up the event listeners when the component unmounts
        return () => {
            document.removeEventListener('mousemove', moveCursor);
            links.forEach(link => {
                link.removeEventListener('mouseenter', addHoverEffect);
                link.removeEventListener('mouseleave', removeHoverEffect);
            });
        };
    }, []);

    return <div id="custom-cursor"></div>;
};

export default CustomCursor;
